import { useKumoToastManager } from '@cloudflare/kumo'
import { useTranslation } from '../../i18n'
import { shareLink } from '../home/share'

/** Share (Web Share, copy fallback) or just copy an invitation link, with a toast for the outcome. */
export function useShareLink() {
  const { t } = useTranslation()
  const toasts = useKumoToastManager()

  return async function share(url: string, copyOnly = false): Promise<void> {
    const outcome = copyOnly
      ? await navigator.clipboard.writeText(url).then(
          () => 'copied' as const,
          () => 'failed' as const,
        )
      : await shareLink(url)
    if (outcome === 'copied') {
      toasts.add({ variant: 'success', title: t('dashboard.agenda.linkCopied') })
    } else if (outcome === 'failed') {
      toasts.add({ variant: 'error', title: t('dashboard.agenda.shareFailed') })
    }
  }
}
